import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './expertiseForm';
import List from './expertiseList';

const settings = {
    pathRegister: paths.expertiseRegister,
    pathList: paths.expertise,
    apiPath: 'expertise',
    permissionAdmin: null,
    title: 'Perícia',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Perícias' }} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
